import InvitationListView from "../../components/InvitationListView";

import { Invitation, InvitationMode } from "../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { action } from "@storybook/addon-actions";

const meta = {
    title: "Views/Invitation list",
    component: InvitationListView,
    argTypes: {},
    args: {
        invitations: [
            {
                id: "invitation-1",
                senderName: "Monsieur One",
                clientName: "La compagnie du premier",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Jean",
                lastName: "Dupont",
                createdAt: "2021-01-01T12:00:00Z",
                phoneNumber: "+41799999901",
                token: "token-1",
                text: "Bonjour, je vous invite à rejoindre ma compagnie.",
                mode: InvitationMode.Receiver,
            },
            {
                id: "invitation-2",
                senderName: "Monsieur AvecUnTresLongNom DifficileAWrapper",
                clientName: "La compagnie du second",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Pierre",
                lastName: "Quiroule",
                createdAt: "2021-01-01T12:00:00Z",
                phoneNumber: "+41799999902",
                token: "token-1",
                mode: InvitationMode.Receiver,
            },
            {
                id: "invitation-3",
                senderName: "Monsieur Trois",
                clientName: "La compagnie du troisième",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Paul",
                lastName: "Prevost",
                createdAt: "2021-01-03T12:00:00Z",
                phoneNumber: "+41799999903",
                token: "token-1",
                text: "Allez, bouges toi et viens !",
                mode: InvitationMode.Receiver,
            },
            {
                id: "invitation-4",
                clientName: "La compagnie du troisième",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Paul",
                lastName: "Prevost",
                createdAt: "2021-01-03T12:00:00Z",
                phoneNumber: "+41799999903",
                token: "token-2",
                text: "Allez, bouges toi et viens !",
                mode: InvitationMode.Sender,
                senderName: "Monsieur Trois",
            },
        ],
    },
} satisfies Meta<typeof InvitationListView>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        onSelectInvitation: (invitation: Invitation) => {
            action(`Invitation selected: ${invitation.id}`);
        },
    },
};

export const ReadOnly: Story = {
    args: {},
};
